interface OGPPaymentsProps {
  title: string;
  description: string;
}

export function OGPPayments({
  title,
  description,
}: OGPPaymentsProps): JSX.Element {
  return (
    <>
      <meta name="description" content={description} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={`${title} | OneFootball`} />
      <meta property="og:description" content={description} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="onefootball.com" />
      <meta name="twitter:title" content={`${title} | OneFootball`} />
      <meta name="twitter:description" content={description} />
    </>
  );
}
